<template>
  <div>
    <!-- 教育培训详情 -->
    <nav-common :nav="nav"></nav-common>
    <div class="center-intro-content">
      <item-detail :detail="detail"></item-detail>
    </div>
  </div>
</template>
<style scoped>
.center-intro-content {
  margin-top: 30px;
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color: #e6ecf2;
  padding: 40px 30px;
  box-sizing: border-box;
  border-radius: 10px;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      nav: {
        firsttitle: "人事",
        firstrouteName: "education",
        secondtitle: "教育培训",
        secondrouteName: "education",
        thirdtitle: "文章详情",
        thirdrouteName: ""
      },
      detail: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      userApi.getpersonDeatil({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    navCommon,
    itemDetail
  }
};
</script>





// WEBPACK FOOTER //
// src/components/views/Personnel/Children/detail.vue